import { COLOR_CODES } from "../../../common";
import { lightenColor } from "../../../components/recharts/ReMixCharts";
import { getRandomColor, stringToConsistentColor } from "../../../extensions/string";
import { ChartType } from "../../../models/chart_model";
import { GasData } from "../../../models/gas";

export const CHART_TYPES = [
    { value: ChartType.Bar, label: "Standard Bar", stackId: undefined},
    { value: ChartType.Bar, label: "Stacked Bar", stackId: "a" },
    { value: ChartType.Line, label: "Line" },
  ];

// export const FUNCTION_TYPES = [
//   {
//     value: "Cumulative", label: "Cumulative", average: false},
//   {
//     value: "average", label: "Average(Per Month)", average: true},
    
// ];

export const INTERVALS = [
  {
    key: "month",
    label: "Month",
  },
  {
    key: "quarter",
    label: "Quarter"
  },
  {
    key: "year",
    label: "Calendar Year",
  },
  {
    key: "fyear",
    label: "Fiscal Year"
  },

]

export const GAS_PRODUCTION_TYPE = [
  {value: "net_production_mmscmd", label: "Net Production"},
  {value: "gross_production_mmscmd", label: "Gross Production"},
]
export const GAS_BAR_GAP = 10;
export const GAS_COLORS = {
  rlng_imported_long_term_contratcs: "#64B5F6",  // Darker Blue
  domestic_gas_alloted_mmscmd_total: "#FFB74D",  // Darker Orange
  gas_consumed_supplied_mmscmd_rlng_imported_spot: "#81C784",  // Darker Green
  gas_consumed_supplied_mmscmd_rlng_imported_long_term: "#E57373",  // Darker Red (Pinkish)
  gas_consumed_supplied_mmscmd_domestic_total: "#9575CD",  // Darker Purple
  tentative_generation_during_the_month_mus: "#616161",  // Darker Gray
  "Onshore Net Production": lightenColor(COLOR_CODES.secondary, 30),
  "Offshore Net Production": lightenColor(COLOR_CODES.primary, 10),
  "Onshore Gross Production": lightenColor(COLOR_CODES.primary, 10),
  "Offshore Gross Production":lightenColor(COLOR_CODES.secondary, 30),
  "Net Production": lightenColor(COLOR_CODES.primary, 10),
  "Gross Production": lightenColor(COLOR_CODES.secondary, 30),
  "Domestic Consumption":lightenColor(COLOR_CODES.primary, 10) ,
  "RLNG Consumption":lightenColor(COLOR_CODES.secondary, 30),
  "Total Consumption":lightenColor(COLOR_CODES.secondary, 20),
  "Imported":lightenColor(COLOR_CODES.secondary, 20),


  "Domestic Consumption Compare":(COLOR_CODES.primary) ,
  "Total Consumption Compare":lightenColor(COLOR_CODES.primary, 20),

  "RLNG Consumption Compare":lightenColor(COLOR_CODES.primary, 20),
  "Net Production Compare":(COLOR_CODES.secondary),
  "Gross Production Compare":COLOR_CODES.secondary,
  "Imported Compare":lightenColor(COLOR_CODES.secondary, 30),



};

export function getGasColors(key: string, index?: number): string {
  key = key.trim();
  if (GAS_COLORS[key as keyof typeof GAS_COLORS]) {
    return GAS_COLORS[key as keyof typeof GAS_COLORS];
  }
  else{
    return getRandomColor(index || 0);
  }
}



export function getAvailableMonths(data: GasData[]): { value: string; label: string; }[] {
  return Array.from(new Set(data.map((item) => {
    return { value: item.month_year, label: item.month_year };
  })))
  .sort((a, b) => {
    const [monthA, yearA] = a.label.split('-');
    const [monthB, yearB] = b.label.split('-');

    // Create a Date object to ensure proper sorting by month and year
    const dateA = new Date(`${monthA}-01-${yearA}`);
    const dateB = new Date(`${monthB}-01-${yearB}`);
    
    return dateA.getTime() - dateB.getTime();
  })
  .filter(
    // value must be unique
    (value, index, self) => self.findIndex((t) => t.value === value.value) === index
  );
}
